<template>
  <RevDrawer :name="MODAL_NAMES.KEYBOARD" :title="i18n(translations.title)">
    <template #body>
      <ul>
        <li v-if="defaultKeyboard" class="mb-12">
          <label class="group relative block cursor-pointer">
            <input
              :checked="defaultKeyboard.selected"
              class="absolute inset-0 opacity-0"
              :name="`step-keyboard-other`"
              type="radio"
              :value="defaultKeyboard.trackingValue"
              @keydown.enter="emit('click', defaultKeyboard, -2)"
            />
            <LargePicker
              class="m-auto h-full group-focus-within:outline-default-hi group-focus-visible:outline-default-hi"
              :index="-2"
              :label="defaultKeyboard.label as string"
              :loading="loading && loadingIndex === -2"
              :price="i18n.price(defaultKeyboard.price ?? '')"
              :selected="defaultKeyboard.selected"
              :sub-label="defaultKeyboard.subLabel as string"
              @click="emit('click', defaultKeyboard, -2)"
            />
          </label>
        </li>
        <li
          v-if="
            selectedKeyboard &&
            defaultKeyboard?.label !== selectedKeyboard.label
          "
          class="mb-12"
        >
          <label class="group relative block cursor-pointer">
            <input
              :checked="selectedKeyboard.selected"
              class="absolute inset-0 opacity-0"
              :name="`step-keyboard-other`"
              type="radio"
              :value="selectedKeyboard.trackingValue"
              @keydown.enter="emit('click', selectedKeyboard, -1)"
            />
            <LargePicker
              class="m-auto h-full group-focus-within:outline-default-hi group-focus-visible:outline-default-hi"
              :index="-1"
              :label="selectedKeyboard.label as string"
              :loading="loading && loadingIndex === -1"
              :price="i18n.price(selectedKeyboard.price ?? '')"
              :selected="selectedKeyboard.selected"
              :sub-label="selectedKeyboard.subLabel as string"
              @click="emit('click', selectedKeyboard, -1)"
            />
          </label>
        </li>
        <li
          v-for="(option, index) in options"
          :key="option.label as string"
          class="mb-12 last:mb-0 md:hidden"
        >
          <label class="group relative block cursor-pointer">
            <input
              :checked="option.selected"
              class="absolute inset-0 opacity-0"
              :name="`step-keyboard-other`"
              type="radio"
              :value="option.trackingValue"
              @keydown.enter="emit('click', option, index)"
            />
            <LargePicker
              class="m-auto h-full group-focus-within:outline-default-hi group-focus-visible:outline-default-hi"
              :index
              :label="option.label as string"
              :loading="loading && loadingIndex === index"
              :price="i18n.price(option.price ?? '')"
              :selected="option.selected"
              @click="emit('click', option, index)"
            />
          </label>
        </li>
      </ul>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import type { Step } from '../../../../utils/types'
import LargePicker from '../../../LargePicker/LargePicker.vue'

import translations from './KeyboardModal.translations'

defineProps<{
  options: Step['options']
  loading: boolean
  loadingIndex: number | null
  selectedKeyboard?: Step['options'][number]
  defaultKeyboard?: Step['options'][number]
}>()

const emit = defineEmits<{
  (e: 'click', option: Step['options'][number], index: number): void
}>()

const i18n = useI18n()
</script>
